export default "__VITE_ASSET__CVjWTPHu__"